import React, { useState, useEffect, Link } from "react";
import axios from "axios";
import { Cookies } from "../../index.js";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { alert_error, alert_success } from "../../AppContext";
import { useSelector, useDispatch } from 'react-redux';
import Orders_done from '../../shop/ai/orders/orders_done.jsx';
import { update_api_response, update_amount_orders, update_discount_orders, update_money_orders, update_category_pro_lite, update_users_status, update_input_url_orders, update_scams_lists_search, update_scams_lists_show, update_accounts_search_results } from './actions';
import Ticket_holder from './ticket_holder';
import Service from './service';
import Category from './category';
import Input_users from './input_users';
import Home_cards from '../../community/content/home_cards.jsx';
import Accounts_lists_vip from '../account/orders/services/lists_vip.jsx';
import Language_i18 from '../../js/useNationalLanguage.jsx';

function Ordergoogle({ category_main, api_categorymini, servicecode }) {
    const { slug_1, slug_2, slug_3 } = useParams();
    const { lang } = Language_i18();
    const categoryMain = category_main || api_categorymini;
    const [searchParams] = useSearchParams();
    const items = useSelector(state => state.items);
    const money_orders = useSelector(state => state.money_orders);
    const images_data = useSelector(state => state.images_data);
    const amount_orders = useSelector(state => state.amount_orders);
    const price_orders = useSelector(state => state.price_orders);
    const users_view_max = useSelector(state => state.users_view_max);
    const discount_orders = useSelector(state => state.discount_orders);
    const services_orders = useSelector(state => state.services_orders);
    const comments_orders = useSelector(state => state.comments_orders);
    const username_orders = useSelector(state => state.username_orders);
    const input_url_orders = useSelector(state => state.input_url_orders);
    const api_response = useSelector(state => state.api_response);
    const accounts_search_results = useSelector(state => state.accounts_search_results);
    const dispatch = useDispatch();
    const [newOrder, setNewOrder] = useState('');
    const navigate = useNavigate();
    const set_money_orders = (value) => {
        dispatch(update_money_orders(value));
    };
    const set_amount_orders = (value) => {
        dispatch(update_amount_orders(value));
    };
    const set_discount_orders = (value) => {
        dispatch(update_discount_orders(value));
    };
    const set_api_response = (value) => {
        dispatch(update_api_response(value));
    };
    const set_users_status = (value) => {
        dispatch(update_users_status(value));
    };
    const set_input_url_orders = (value) => {
        dispatch(update_input_url_orders(value));
    };
    const set_scams_lists_search = (value) => {
        dispatch(update_scams_lists_search(value));
    };
    const set_scams_lists_show = (value) => {
        dispatch(update_scams_lists_show(value));
    };
    const set_accounts_search_results = (value) => {
        dispatch(update_accounts_search_results(value));
    };

    const [nutorder, setnutorder] = useState("Please wait a moment 😊 ok");
    const [nutxuly, setnutxuly] = useState(1);
    const [amount, setamount] = useState("");
    const [commentsok, setcommentsok] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [isOpen2, setIsOpen2] = useState(false);
    const [isOpen3, setIsOpen3] = useState(false);
    const [isOpen4, setIsOpen4] = useState(false);
    const [service, setservice] = useState(true);
    const [service2, setservice2] = useState(true);
    const [isDisabled, setIsDisabled] = useState(false);
    const showAccountsSearchResults = categoryMain === 'accounts_search'
        && Array.isArray(accounts_search_results)
        && accounts_search_results.length > 0;

    function saochep(value) {
        alert_success('Đã sao chép');
        window.saochepnative(value);

    };
    const handleCommentsChange = () => {
        const amountok = commentsok.split("\n").length;
        setamount(amountok);
        // set_amount_orders(amountok);
        tinhgia(amountok);
    };
    useEffect(() => {
        handleCommentsChange();
    }, [commentsok]);


    function tinhgia2(amountok, rate) {
        const giagiamok = rate * amountok * discount_orders / 100;
        const giaok = rate * amountok - giagiamok;
        set_money_orders(giaok);
    }
    function tinhgia(amountok) {
        console.log(service2.money);
        if (service.category == 'search') {
            tinhgia2(amountok, service2.money);
        }
        else {
            tinhgia2(amountok, service.money);
        }
    }


    function testFunction(response, services_orders) {
        const info = response.data;
        const orderok = info.order;
        const note = info.note;
        const error = info.error;
        const data = info.data;
        const isAccountsSearch = categoryMain === 'accounts_search';
        const searchResults = (() => {
            if (!isAccountsSearch) {
                return null;
            }
            if (Array.isArray(data)) {
                return data;
            }
            if (Array.isArray(data?.data)) {
                return data.data;
            }
            if (Array.isArray(data?.accounts)) {
                return data.accounts;
            }
            if (Array.isArray(info?.accounts)) {
                return info.accounts;
            }
            return null;
        })();

        set_api_response(info);
        setnutorder("đặt tiếp luôn nào");
        setnutxuly(0);
        if (!error && Array.isArray(searchResults)) {
            set_accounts_search_results(searchResults);
        }
        if (error) {
            alert_error(info.error);
        } else if (orderok) {
            if (services_orders.category == "videos_maker") {
                setIsDisabled(true);
            }
            alert_success('Thankiuu Bạn là người thứ ' + orderok + ' ủng hộ Hust Media');
            if (note == 'un_block_users') {
                Cookies.set('users_status', '1');
                set_users_status('1');
            }
        }
        else {
            if (services_orders.category == "scams_check") {
                set_scams_lists_search(data);
                setTimeout(() => {
                    set_scams_lists_show(true);
                }, 100);
            } else if (Array.isArray(searchResults)) {
                // search results already stored; no error toast
            } else {
                alert_error('Lỗi không xác định vui lòng liên hệ admin');
            }
        }
        if (info.redirect != null && info.redirect != "") {
            setTimeout(function () {
                // Chuyển hướng sang trang web khác
                window.location.href = info.redirect;
            }, 1700);
        } if (info.order && info.orderxu) {
            const orderxu = info.orderxu;
            setTimeout(() => {
                navigate('/shop/bill/' + orderxu);
            }, 100);
        }
    }
    function handleSubmit(event) {
        setnutxuly(0);
        const apikey = Cookies.get("apikey");
        const national_market = Cookies.get("national_market");
        event.preventDefault();

        setnutxuly(1);
        setnutorder("Please wait a moment 😊");
        if (!input_url_orders) {
            alert("Please điền đầy đủ thông tin");
            setnutxuly(0);
            setnutorder("điền đủ thông tin");
            return;
        }
        const postData = {
            action: 'add',
            comments: comments_orders,
            key: apikey,
            link: input_url_orders,
            username: username_orders,
            quantity: amount_orders,
            national_market: national_market,
            service: services_orders.id,
            ...( services_orders?.typeapi?.includes("p2p_mmo")
                ? { price_orders: price_orders, users_view_max: users_view_max }
                : {})
        };

        // Only include `images_data` if it's not empty or undefined
        if (images_data && images_data.length > 0) {
            postData.images_data = images_data;
        }

        axios
            .post("https://hust.media/api/v3", postData)
            .then((response) => testFunction(response, services_orders))
            .catch((error) => loimatroi(error));
    }
    const loimatroi = (error) => {
        alert_error(error);
        setnutorder("Thử lại xem");
        setnutxuly(0)
    };

    useEffect(() => {
        setamount('');
        if (!slug_3) {
            dispatch(update_category_pro_lite(''));
            closeOtherDropdowns('starts', [setIsOpen, setIsOpen2, setIsOpen3, setIsOpen4]);
        } else {
        }
        if (servicecode == 'continue' && categoryMain == 'videos_maker') {
            setIsDisabled(true);
        }
    }, []);

    const closeOtherDropdowns = (isOpen, setStates) => {
        if (isOpen || isOpen == 'starts') {
            // alert(isOpen);
            setStates.forEach(setState => setState(false));
        }
    };

    useEffect(() => {
        closeOtherDropdowns(isOpen, [setIsOpen2, setIsOpen3, setIsOpen4]);
    }, [isOpen]);
    useEffect(() => {
        closeOtherDropdowns(isOpen2, [setIsOpen, setIsOpen3, setIsOpen4]);
    }, [isOpen2]);
    useEffect(() => {
        closeOtherDropdowns(isOpen3, [setIsOpen, setIsOpen2, setIsOpen4]);
    }, [isOpen3]);
    useEffect(() => {
        closeOtherDropdowns(isOpen4, [setIsOpen, setIsOpen2, setIsOpen3]);
    }, [isOpen4]);

    const peding_service = (value) => {
        if (!value) {
            setnutorder('✔️ Click to Confirm');
            setnutxuly(0);
        } else if (value) {
            setnutorder('Please wait a moment 😊');
            setnutxuly(1);
        }
    }
    return (
        <>
            <div className="mt-1 mx-2">
                <div className="mt-1 add-form">
                    <div className="form-control">
                        {
                            (slug_1 != 'plans' && !categoryMain) && (<>
                                <Category
                                    setnutxuly={setnutxuly}
                                    setnutorder={setnutorder}
                                    peding_service={peding_service}
                                    isOpen3={isOpen3}
                                    isOpen4={isOpen4}
                                    setIsOpen3={setIsOpen3}
                                    setIsOpen4={setIsOpen4} />
                            </>)
                        }

                        <Service
                            peding_service={peding_service}
                            isOpen={isOpen}
                            isOpen2={isOpen2}
                            setIsOpen={setIsOpen}
                            setIsOpen2={setIsOpen2}
                            category_main={categoryMain}
                            api_categorymini={api_categorymini}
                            servicecode={servicecode}
                            tinhgia={tinhgia}
                        />
                        {(slug_1 == 'product' && slug_2 == 'play') ? (<>

                        </>) : (<>                         {
                            (slug_1 != 'plans' && !categoryMain) && (<>
                                <label className="text-sm">Link,id app, post, video, username cần thực thi</label>
                                <br />
                                <div className="input-group flex-nowrap">
                                    <span className="input-group-text" id="addon-wrapping">
                                        url
                                    </span>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Copy và điền liên kết ở đây"
                                        aria-label="input_url_orders"
                                        value={input_url_orders}
                                        name="input_url_orders"
                                        aria-describedby="addon-wrapping"
                                        onChange={(e) => set_input_url_orders(e.target.value)}
                                    />
                                </div>       </>)
                        }
                            <Input_users
                                input_url_orders={input_url_orders}
                                set_input_url_orders={set_input_url_orders}
                                isDisabled={isDisabled}
                                setIsDisabled={setIsDisabled}
                            />
                            <button
                                disabled={nutxuly}
                                onClick={handleSubmit}
                                className="mt-1 flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-2 w-full dark:bg-slate-800 dark:text-white"
                            >
                                <div className="flex items-center justify-between flex-1">
                                    {nutxuly == 1 && (
                                        <div className="spinner-border" role="status"></div>
                                    )}

                                    <span className="text-lg font-medium text-white">
                                        {nutorder}{" "}
                                    </span>
                                    <div className="text-xl">
                                        {'\u27A4'}
                                    </div>
                                </div>
                            </button>
                            <Orders_done />
                            <Ticket_holder /></>)}

                        {showAccountsSearchResults && (
                            <Accounts_lists_vip services_categorys={accounts_search_results} isOpen={isOpen} setIsOpen={setIsOpen} />
                        )}
                        <div className="text-center justify-center text-xs px-4">
                            {lang === "vi"
                                ? "Tạo chiến dịch phải tuân thủ luật pháp. Nhận diện thương hiệu an toàn quy định các ứng dụng"
                                : "Campaigns must comply with the law. Safe brand identity follows platform policies."}
                        </div>
                    </div>
                </div>
                {
                    !Cookies.get("apikey") && (<>
                        {/* <Home_cards /> */}
                    </>)
                }

            </div>
        </>
    );
}

export default Ordergoogle;
